import axiosInstance from "@/common/interceptors/axiosInstance";
import type { AgenticCheckoutFunnelResponse } from "@/types/agentic-checkout";
import { readAnalyticsEnvelope, type AnalyticsEnvelope } from "./analytics.api";

/** The funnel with its response meta, which the page's tiles print as their as-of time (ANL-E04-S09). */
export const fetchAgenticCheckoutFunnel = async (
  start: string,
  end: string
): Promise<AnalyticsEnvelope<AgenticCheckoutFunnelResponse>> => {
  const { data } = await axiosInstance.get(
    "/v1/admin/agentic-checkout/funnel",
    { params: { start, end } }
  );
  return readAnalyticsEnvelope<AgenticCheckoutFunnelResponse>(
    data,
    "agentic checkout funnel"
  );
};
